/**
 * API Base URL and Endpoints configuration
 *
 * Production URL:  https://apis.roomrounds.com
 * Development URL: https://roomroundapis.rootpointers.net
 */

const rawBaseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://apis.roomrounds.com";

// Remove any trailing slash(es)
export const API_BASE_URL = rawBaseUrl.replace(/\/+$/, "");

export const API_ENDPOINTS = {
  // Stripe Checkout
  stripeCheckout: `${API_BASE_URL}/api/Stripe/createCheckoutSession`,

  // Organization
  saveOrganizationDraft: `${API_BASE_URL}/api/organization/saveOrganizationDraft`,
  saveOrganizationFreeTrial: `${API_BASE_URL}/api/organization/saveOrganizationFreeTrial`,

  // Contact Us
  sendContactUsEmail: `${API_BASE_URL}/api/ContactUs/sendContactUsEmail`,
};
